var map = {
	"./angpao.webp": 2337,
	"./bonus.webp": 2338,
	"./gpi-rebate-m.webp": 2339,
	"./gpi-rebate.webp": 2340,
	"./hublot-watch-2018.webp": 2341,
	"./hublot-watch-2022.webp": 2342,
	"./iphone-13-pro-max.webp": 2343,
	"./iphone-14-pro-max.webp": 2344,
	"./login-to-m.webp": 2345,
	"./login-to.webp": 2346,
	"./mb.webp": 2347,
	"./mg-rebate-m.webp": 2348,
	"./mg-rebate.webp": 2349,
	"./np.webp": 2350,
	"./pointer.webp": 2351,
	"./pp-rebate-m.webp": 2352,
	"./pp-rebate.webp": 2353,
	"./sadface.webp": 2354,
	"./wallet-m.webp": 2355,
	"./wallet.webp": 2356,
	"./wheel-b.webp": 2357,
	"./wheel-btn.webp": 2358,
	"./wheel-indon-b.webp": 2359,
	"./wheel-indon.webp": 2360,
	"./wheel.webp": 2361
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 939;